import styled from 'styled-components';
import { vars, media, pxToRem } from '$util/theme';

export const Styled = styled.div`
  display: inherit;
  flex-direction: inherit;
  flex-grow: inherit;

  .ant-form-vertical {
    display: inherit;
    flex-direction: inherit;
    flex-grow: inherit;
    justify-content: space-between;
  }

  .forgot-password-modal__instructions {
    font-size: 15px;
    text-align: center;
    max-width: 300px;
    margin: 0 auto;
    + .ant-row {
      margin-top: 20px;
    }
  }

  .forgot-password__back {
    margin-top: 16px;
    text-align: center;
  }

  ${media.down('md')} {
    width: 100%;
  }
  ${media.up('md')} {
    width: 432px;
  }

  margin: 0px auto;
  font-weight: ${vars.fontWeight.regular};

  .FormItem {
    > :first-child {
      margin-top: 53px;

      ${media.up('md')} {
        margin-top: 23px;
      }
    }
    .Input {
      height: 60px;
    }
  }

  .forgot-password {
    ${media.up('md')} {
      text-align: right;
    }
  }

  .anticon-check-circle {
    display: none;
  }

  .-error {
    label {
      color: ${vars.red};
    }
    .item-error {
      color: ${vars.red};
      font-size: ${pxToRem(13)};
    }
  }
`;
